var map = {
	"./Academy.png": 5888,
	"./Blog.png": 1849,
	"./Booking.png": 4214,
	"./CRM.png": 8264,
	"./Cloud Storage.png": 3457,
	"./ERP.png": 6977,
	"./Ecommerce.png": 2540,
	"./Food Delivery.png": 6044,
	"./HR.png": 654,
	"./Jobs.png": 7489,
	"./LMS.png": 3406,
	"./Menu.png": 9613,
	"./Multi Vendor.png": 6672,
	"./Project Management.png": 4745,
	"./School Management.png": 1779,
	"./Sell and Buy.png": 8882,
	"./Task Management.png": 1116,
	"./Taxi.png": 5208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4477;